import { render, staticRenderFns } from "./NKWsByProviderTable.vue?vue&type=template&id=f4656b1c&scoped=true&"
import script from "./NKWsByProviderTable.vue?vue&type=script&lang=js&"
export * from "./NKWsByProviderTable.vue?vue&type=script&lang=js&"
import style0 from "./NKWsByProviderTable.vue?vue&type=style&index=0&id=f4656b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4656b1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
